<p-table stripedRows #dataTable
    [value]="items"
    dataKey="id"
    editMode="row"
    [(selection)]="selected"
    [style]="{ width: '100%', 'min-width': '90em' }"
    scrollHeight="flex"
    [scrollable]="true"
    selectionMode="Multiple"
    (selectionChange)="SelectItem.next($event)"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Selection -->
            <th class="select-cell">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <!-- Contractdesc -->
            <th pSortableColumn="Contractdesc">
                Contract
                <p-sortIcon
                    field="Contractdesc"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="Contractdesc" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            defaultLabel="Filter"
                            maxSelectedLabels="1"
                            appendTo="body"
                            [options]="contracts"
                            [filter]="true"
                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                        ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Contracttype -->
            <th pSortableColumn="Contracttype">
                Type
                <p-sortIcon
                    field="Contracttype"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Remit Address -->
            <th>
                <div class="tabulator-col-title">Remit Address</div>
            </th>
            <!-- Bill Address -->
            <th>
                <div class="tabulator-col-title">Bill Address</div>
            </th>
            <!-- Feeseparate -->
            <th pSortableColumn="Feeseparate">
                Separate Fee
                <p-sortIcon
                    field="Feeseparate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- ShowCN -->
            <th pSortableColumn="ShowCN">
                Show Charge Numbers
                <p-sortIcon
                    field="ShowCN"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Vouchercontractdesc -->
            <th pSortableColumn="Vouchercontractdesc">
                Contract Description
                <p-sortIcon
                    field="Vouchercontractdesc"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
        <tr
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === item?.id
            }"
        >
            <!-- Edit -->
            <td class="edit-cell">
                <button
                    *ngIf="item?.id === 'add' && !edit"
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-plus"
                    severity="success"
                    text
                    rounded
                    (click)="onRowEditInit(item)"
                ></button>
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== 'add'
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    text
                    rounded
                    (click)="onRowEditInit(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    severity="success"
                    text
                    rounded
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    severity="danger"
                    text
                    rounded
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Selection -->
            <td class="select-cell">
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
            </td>
            <!-- Contractdesc -->
            <td class="disabled">
                {{ item.Contractdesc }}
            </td>
            <!-- Contracttype -->
            <td class="disabled">
                {{ item.Contracttype }}
            </td>
            <!-- Remitaddrid -->
            <td [attr.title]="
                    (remitAddresses | itemlookup: 'value':item?.Remitaddrid)
                        ?.label
                "
            >
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-select
                            [options]="remitAddresses"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Remit To"
                            [(ngModel)]="item.Remitaddrid"
                        >
                        </p-select>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                            (
                                remitAddresses
                                | itemlookup: 'value':item?.Remitaddrid
                            )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            (
                                remitAddresses
                                | itemlookup: 'value':item?.Remitaddrid
                            )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Voucheraddrid -->
            <td [attr.title]="
                    (billingAddresses | itemlookup: 'value':item?.Voucheraddrid)
                        ?.label
                "
            >
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-select
                            [options]="billingAddresses"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Remit To"
                            [(ngModel)]="item.Voucheraddrid"
                        >
                        </p-select>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                            (
                                billingAddresses
                                | itemlookup: 'value':item?.Voucheraddrid
                            )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            (
                                billingAddresses
                                | itemlookup: 'value':item?.Voucheraddrid
                            )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Feeseparate -->
            <td class="disabled">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-checkbox
                            binary="true"
                            [(ngModel)]="item.Feeseparate"
                        ></p-checkbox>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i
                            [ngClass]="{
                                pi: true,
                                'pi-check': item?.Feeseparate,
                                green: item?.Feeseparate
                            }"
                        ></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i
                            [ngClass]="{
                                pi: true,
                                'pi-check': item?.Feeseparate,
                                green: item?.Feeseparate
                            }"
                        ></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- ShowCN -->
            <td class="disabled">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-checkbox
                            binary="true"
                            [(ngModel)]="item.ShowCN"
                        ></p-checkbox>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i
                            [ngClass]="{
                                pi: true,
                                'pi-check': item?.ShowCN,
                                green: item?.ShowCN
                            }"
                        ></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i
                            [ngClass]="{
                                pi: true,
                                'pi-check': item?.ShowCN,
                                green: item?.ShowCN
                            }"
                        ></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Vouchercontractdesc -->
            <td class="large-cell">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input
                            pInputText
                            [(ngModel)]="item.Vouchercontractdesc"
                        />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i
                            [ngClass]="{
                                pi: true,
                                'pi-check': item?.Vouchercontractdesc,
                                green: item?.Vouchercontractdesc
                            }"
                        ></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.Vouchercontractdesc }}
                    </ng-template>
                </p-cellEditor>
            </td>
        </tr>
    </ng-template>
</p-table>
